<template>
  <customDialog
    v-model="show"
    title="clock_out"
    width="600px"
    :footer="false"
    :closeBtn="true"
  >
    <template #activator>
      <div v-if="shift">
        <v-alert type="info" outlined dense class="mb-3">
          <div class="text-body-2">
            <div>
              <strong>{{ $t("staff_name") }}:</strong>
              {{ shift.user ? shift.user.first_name : "-" }}
            </div>
            <div>
              <strong>{{ $t("shift_period") }}:</strong>
              {{ shift.clock_in_at | moment("YYYY-MM-DD HH:mm") }} -
              {{ shift.clock_out_at | moment("YYYY-MM-DD HH:mm") }}
            </div>
          </div>
        </v-alert>

        <v-row class="mb-3">
          <v-col cols="6">
            <v-card outlined>
              <v-card-text>
                <div class="text-caption grey--text">{{ $t("opening_cash") }}</div>
                <div class="text-h6">{{ shift.opening_cash | NumberFormat }}</div>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="6">
            <v-card outlined>
              <v-card-text>
                <div class="text-caption grey--text">{{ $t("total_sales") }}</div>
                <div class="text-h6 primary--text">
                  {{ (shift.total_sales || 0) | NumberFormat }}
                </div>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>

        <v-row class="mb-3">
          <v-col cols="6">
            <v-card outlined>
              <v-card-text>
                <div class="text-caption grey--text">{{ $t("cash_in") }}</div>
                <div class="text-h6 primary--text">
                  {{ (shift.cash_in_total || 0) | NumberFormat }}
                </div>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="6">
            <v-card outlined>
              <v-card-text>
                <div class="text-caption grey--text">{{ $t("cash_out") }}</div>
                <div class="text-h6 red--text">
                  {{ (shift.cash_out_total || 0) | NumberFormat }}
                </div>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>

        <v-divider class="my-3"></v-divider>

        <v-row class="mb-3">
          <v-col cols="12">
            <v-card outlined>
              <v-card-text>
                <div class="d-flex justify-space-between align-center">
                  <div>
                    <div class="text-caption grey--text">
                      {{ $t("expected_cash") }}
                    </div>
                    <div class="text-h5">
                      {{ expectedCash | NumberFormat }}
                    </div>
                  </div>
                  <v-icon large color="primary">fal fa-arrow-right</v-icon>
                  <div>
                    <div class="text-caption grey--text">
                      {{ $t("actual_cash") }}
                    </div>
                    <div class="text-h5">
                      {{ (shift.closing_cash || 0) | NumberFormat }}
                    </div>
                  </div>
                </div>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>

        <v-alert
          :type="variance >= 0 ? 'success' : 'error'"
          outlined
          dense
          class="mt-3"
        >
          <div class="text-body-2">
            <strong>{{ $t("variance") }}:</strong>
            <span :class="variance >= 0 ? 'primary--text' : 'red--text'">
              {{ variance | NumberFormat }}
            </span>
          </div>
        </v-alert>
      </div>
    </template>
  </customDialog>
</template>

<script>
import customDialog from "@/components/customDialog";
import { myMixin } from "@/mixin/main";

export default {
  name: "ClockOutDetailDialog",
  components: { customDialog },
  mixins: [myMixin],
  props: {
    value: Boolean,
    shift: {
      type: Object,
      default: null,
    },
  },
  computed: {
    show: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    expectedCash() {
      if (!this.shift) return 0;
      const opening = Number.parseFloat(this.shift.opening_cash) || 0;
      const sales = Number.parseFloat(this.shift.total_sales) || 0;
      const cashIn = Number.parseFloat(this.shift.cash_in_total) || 0;
      const cashOut = Number.parseFloat(this.shift.cash_out_total) || 0;
      return opening + sales + cashIn - cashOut;
    },
    variance() {
      const actual = Number.parseFloat(this.shift?.closing_cash) || 0;
      return actual - (this.expectedCash || 0);
    },
  },
};
</script>

